import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 50px;
  position: relative;
  @media screen and (max-width: 480px) {
    margin-bottom: 30px;
  }
`;

export const PaginationWrapper = styled.div`
  display: flex;
`;
export const Prev = styled.button`
  border: 1px solid black;
  width: 40px;
  height: 30px;
  background: white;
  cursor: pointer;
  @media screen and (max-width: 480px) {
    width: 30px;
    height: 26px;
    font-size: 10px;
  }
`;
export const Dots = styled.div`
  border: 1px solid black;
  width: 25px;
  height: 30px;
  text-align: center;
  cursor: pointer;
  @media screen and (max-width: 480px) {
    width: 18px;
    height: 26px;
  }
`;
export const Next = styled.button`
  border: 1px solid black;
  width: 40px;
  height: 30px;
  background: white;
  cursor: pointer;
  @media screen and (max-width: 480px) {
    width: 30px;
    height: 26px;
    font-size: 10px;
  }
`;
export const NumberBtn = styled.button`
  border: 1px solid black;
  width: 25px;
  height: 30px;
  background: white;
  cursor: pointer;

  &:active {
    background: black;
    color: white;
  }
  @media screen and (max-width: 480px) {
    width: 18px;
    height: 26px;
    font-size: 11px;
  }
`;

export const PageIndicator = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  @media screen and (max-width: 480px) {
    right: 10px;
  }
`;

export const IndicatorText = styled.span`
  color: #827777;
  font-size: 14px;

  @media screen and (max-width: 480px) {
    font-size: 8px;
  }
`;
